// extracted by mini-css-extract-plugin
export var boxItems = "_84-1";
export var boxItemsLg = "_84-2";
export var button = "_84-7";
export var buttonLg = "_84-8";
export var filterGroupBox = "_84-0";
export var icon = "_84-3";
export var iconSecondary = "_84-6";
export var iconWrapper = "_84-4";
export var iconWrapperLg = "_84-5";